<div class="wrapper">
  <div class="header-title">
    <h1 class="header-title-shopper">Merchant Sign-Up Form</h1>
  </div>
  <mat-card>
    <mat-card-content>
      <app-partner-apply-snip
        buttonColor="#f15855"
        buttonTextColor="rgb(240, 240, 240)"
        inputStyle="fill"
        (submitEvent)="submit($event)"
      ></app-partner-apply-snip>
      <!-- <fevertree-partner-signup
        buttonColor="#f15855"
        buttonTextColor="rgb(240, 240, 240)"
        inputStyle="fill"
        (submitEvent)="submit($event);">
      </fevertree-partner-signup> -->
    </mat-card-content>
  </mat-card>
</div>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
></ngx-spinner>
